/* eslint-disable */
import { CaretIcon, H4, HorizontalSpacer, PeopleOutlined } from 'components';
import { CollapseContainer, FilterSection, FilterTitle, Tag, TagsContainer, TitleGroup } from './panelStyles';
import { withTheme } from 'styled-components';
import { useSelector } from 'react-redux';
import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { paramsFromURL, paramsToObject } from 'utils/paramHelpers';
import { decode } from 'utils';
import { ModelContext } from 'pages/Home/ModelContext';
import { useMemo } from 'react';


const TeamMemberSection = withTheme(props => {
    const { theme } = props;

    const { getModels, getTeamData } = useContext(ModelContext);

    const [ searchParams, setSearchParams ] = useSearchParams();
    const params = paramsToObject(decode(paramsFromURL()));

    const userDataStore = useSelector(state => state.userData);
    const teamDataStore = useSelector(state => state.teamData);

    const userPreferences = userDataStore.userPreferences;
    const filterPanel = userPreferences.filterPanel;
    const selectedTheme = userPreferences.theme;
    const { mediumGrey, accent } = theme.colors[selectedTheme];

    const { selectedTeamId } = teamDataStore;

    const teamMembers = useMemo(() => teamDataStore.users, [ teamDataStore.users ]);

    useEffect(() => {
        getTeamData(selectedTeamId);
    }, [ selectedTeamId ]);

    const [ isCollapsed, setIsCollapsed ] = useState(false);

    const searchedMembers = searchParams.getAll('user_ids');
    const uniqueMembers = searchedMembers ? new Set(searchedMembers.map(x => Number(x))) : new Set();

    const buildMembers = () => {
        const members = teamMembers
            .toSorted(member => {
                if (uniqueMembers.has(member.userId)) return -1;
                return 1;
            }).map(member => {
                return (
                    <Tag
                        key={member.email}
                        theme={theme}
                        $selectedTheme={selectedTheme}
                        active={uniqueMembers.has(member.userId)}
                        radius={'2rem'}
                        onClick={() => {
                            uniqueMembers.has(member.userId) ? uniqueMembers.delete(member.userId) : uniqueMembers.add(member.userId);
                            setSearchParams({
                                ...params,
                                page: 1,
                                user_ids: Array.from(uniqueMembers)
                            });
                            getModels();
                        }}
                    >
                        {member.email}
                    </Tag>
                );
            });

        return members;
    };

    return (
        <FilterSection collapsed={filterPanel}>
            <FilterTitle>
                <TitleGroup>
                    <PeopleOutlined color={'accent'} $selectedTheme={selectedTheme} />
                    <HorizontalSpacer size={6} />
                    <H4>Team Members</H4>
                </TitleGroup>
                <CollapseContainer onClick={() => setIsCollapsed(!isCollapsed)} >
                    <CaretIcon color={mediumGrey} hoverColor={accent} rotate={isCollapsed ? 0 : 180} />
                </CollapseContainer>
            </FilterTitle>

            <FilterSection collapsed={isCollapsed} paddingOffset="0">
                <TagsContainer>
                    {buildMembers()}
                </TagsContainer>
            </FilterSection>

        </FilterSection>
    );
});

export { TeamMemberSection };
